<template>
<div>
  <v-row>
    <v-col>
      <div>
        <div>
          <v-file-input
            v-model="uploadFile"
            label="File to Upload"
            outlined
            dense
            accept=".csv,.xlsx"
            truncate-length="64"
            @click:clear="clearFile"
            @change="getMetadata"
            :loading="loading"

          >
          </v-file-input>
        </div>
        <div>
          <v-text-field
            label="Descriptive Name"
            v-model="descriptiveName"
            outlined
            dense
            class="ml-4 pl-4 mb-3"
          ></v-text-field>
        </div>
         <v-checkbox
         v-model="isShared"
        label="Share with your organization"
    ></v-checkbox>
      </div>
    </v-col>
    <v-col cols="4">
      <v-btn
        outlined
        :color="buttonColor"
        @click.stop="upload"
        :disabled="disableUpload"
        :loading="loading"
      >
        Upload
        <v-icon>mdi-upload</v-icon>
      </v-btn>
      <v-snackbar :value="uploadSuccess && fileName &&!hideMessage" color="success" class="my-3" outlined absolute right dense max-width="100">
        Upload successful
      </v-snackbar>
    </v-col>
  </v-row>
  <div v-for="error in errors">
      <v-alert
      dense
      outlined
      type="error"
      icon="mdi-alert-octagon-outline"
      v-text="error">

    </v-alert>

  </div>
</div>
</template>
<script>
import XLSX from 'xlsx'
import axios from 'axios'
import {get, set} from '@/utils/utils'


export default {
  data() {
    return {
      workbook: null,
      uploadFile: null,
      fileData: null,
      fileDataJson: null,
      rawData: null,
      fileName: null,
      fileSize: null,
      descriptiveName: null,
      errors: [],
      loading: false,
      disableUpload: true,
      buttonColor: "info",
      uploadSuccess: false,
      errors: [],
      isShared: false
    }
  },
  props: {
  hide:{
    type:Boolean
    },
    destination: {
      type: String,
      default: 'custom_location_groups'
    },
    rowLimit: {
      type: Number,
      default: 10000
    }
  },
  computed: {
    isValid: function() {
      return true
    },
    hideMessage(){
        return this.hide ||false
    }
  },
  methods: {
    validate: function() {
      if (this.fileDataJson.length > (this.rowLimit + 1)) {
        this.errors.push(`${this.fileDataJson.length} rows found; limit is ${this.rowLimit}`)
      }
      return this.errors.length < 1
    },
    upload: function() {
      if (this.validate()) {
        this.loading = true
        // this.$store.dispatch('updateState', ['loadingUpload', true])
        this.disableUpload = true
        axios.post(process.env.VUE_APP_API_HOST + '/' + this.destination, {
          name: this.descriptiveName,
          raw_upload: this.fileData,
          is_shared_with_account: this.isShared,
          filename: this.fileName.replace('.csv','').replace('.xlsx','')
        }).then(response => {
//incoming
          this.uploadSuccess = true

            if(this.destination === 'custom_location_groups'){

            this.$store.dispatch('updateState', ['uploadedLocation', response.data.id])
            }
         // this.uploadSuccessful = true


            if(this.destination === 'collections'){
            this.$store.dispatch('updateState', ['colToGenerate', response.data.id])
            }
//end of incoming

        }).finally(response => {

          this.loading = false
          console.log("aqui", this.destination)
          //clear v-input and v-text field on upload
           this.clearFile();
            this.$emit('success');

          if (this.destination == 'custom_location_groups') {
            this.$store.dispatch('updateState', ['customLocationListRefreshedAt', null]);


          }
          if (this.destination == 'collections') {
           this.$store.dispatch('updateState', ['collectionListRefreshedAt', Date.now()])
           this.$store.dispatch('updateState', ['startGenerationCheck', true]);
            this.$store.dispatch('updateState', ['uploadSuccess', true])
          };




          //refresh page so collection (in "generating" state) appears in CollectionsList
          //this triggers mounted in Collections.vue, which triggers periodically checking if the collection is generated yet
          //it's a timeout so users have time to see the success message
         //window.setTimeout(()=>location.reload(), 500)

        })
      }
    },
    clearFile: function() {

      this.fileData = null
      this.fileName = null
      this.fileSize = null
      this.descriptiveName = null
      this.uploadSuccess = false
      this.errors = []
      //clears text in v-file-input
      this.uploadFile = null

    },
    getMetadata: function(e) {
      if (e) {
        this.fileName = e.name
        this.fileSize = e.size
        if (! this.descriptiveName && this.descriptiveName != '') {
          this.descriptiveName = e.name.replace(/\..*/,'').replaceAll('_',' ')
        }
      }
    }
  },
  watch: {
    uploadFile: function(file) {

      if (file) {
        this.disableUpload = false
        this.uploadSuccess = false
        var rABS = typeof FileReader !== 'undefined' && FileReader.prototype && FileReader.prototype.readAsBinaryString;
        var reader = new FileReader();
        var component = this;
        var reader = new FileReader();
        reader.onload = function(e) {
            var data = e.target.result;
            var readtype = rABS ? 'binary' : 'base64';

            component.workbook = XLSX.read(data, {type: readtype, cellDates: true});
            component.fileDataJson = XLSX.utils.sheet_to_json(component.workbook.Sheets[component.workbook.SheetNames[0]]);
            if (component.isValid) {
              component.fileData = XLSX.utils.sheet_to_csv(component.workbook.Sheets[component.workbook.SheetNames[0]]);
            } else {
              //display errors
            }

            // NOTE: the muni UI used XLSX.utils.sheet_to_json -- I think this will be easier to debug
            // component.validateFile(dataArray);
        }
        if(rABS) {
          reader.readAsBinaryString(file)
        } else {
          reader.readAsArrayBuffer(file)
        }
      }
    }
  }
}
</script>
